import React, { useRef, useState, useEffect } from "react";
import Paginacion from "./Paginacion";
import ExportExcel from "./ExportExcel";
import { buscarId, buscarClass } from "../../../../helpers/functions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import FichaGestion from "../FichaGestion";

//Redux
import { connect,useDispatch } from 'react-redux'
import LimitadorFilas from "./LimitadorFilas";
import Search from "./Search";
import { CircularProgress } from "@material-ui/core";
import CircularProgressWithLabel from "./CircularProgressWithLabel";
import { Edit } from "@material-ui/icons";
import ModalBasicwithRedux from "../../../../containers/ModalBasicwithRedux";
import { updateStateModalBasic } from "../../../../actions/modalActions";
import EditInedirank from "./EditInedirank";


const TableReport = (props) => {

  const { rows, limitador, verNotasSesiones } = props

  const [filas, setFilas] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [currentRows, setCurrentRows] = useState([])
  const [fichaAbierta, setFichaAbierta] = useState(null)
  const [showColMenu, setShowColMenu] = useState(false)
  const [colVisibility, setColVisibility] = useState({
    correo: true, telefono: true, deuda: true,
    notaOptima: true, nota: true, puntosInedi: true,
    puntosEval: true, totalPuntos: true, acciones: true,
    fecha: true, hora: true, observaciones: true, inediTotales: true
  })

  const toggleCol = (col) => setColVisibility(prev => ({ ...prev, [col]: !prev[col] }))

  const columnas = [
    { key: 'correo', label: 'Correo' },
    { key: 'telefono', label: 'Teléfono' },
    { key: 'deuda', label: 'Deuda / Pago' },
    { key: 'notaOptima', label: 'N. Óptima' },
    { key: 'nota', label: 'Nota' },
    { key: 'puntosInedi', label: 'Puntos INEDI' },
    { key: 'puntosEval', label: 'Puntos Evaluaciones' },
    { key: 'totalPuntos', label: 'Total Puntos' },
    { key: 'acciones', label: 'Acciones' },
    { key: 'fecha', label: 'Fecha' },
    { key: 'hora', label: 'Hora' },
    { key: 'observaciones', label: 'Observaciones' },
    { key: 'inediTotales', label: 'Puntos INEDI Totales' },
  ]

  const buscarRef = useRef()
  const dispatch = useDispatch()

  const buscar = (value = '') => {

    let copiaFilas = [...rows]

    if (rows.length === 0) {
      return
    }

    if (value === '') {
      setFilas(rows)
      return
    }


    for (let index = 1; index <= value.length; index++) {
      let acumuladorFilas = []
      copiaFilas.forEach(row => {
        let contadorFila = 0
        Object.keys(row).map(key => {
          if (row[key] !== undefined && row[key] !== null) {
            if (row[key].toString().substr(0, index).toLocaleLowerCase() == value.substr(0, index).toLocaleLowerCase()) {
              if (contadorFila < 1) {
                acumuladorFilas = [...acumuladorFilas, row]
              }
              contadorFila++;
            }
          }
        })
        contadorFila = 0
      })
      setFilas(acumuladorFilas)
    }

  }

  const ordenarColumnas = e => {

    const listaSortable = Array.from(buscarClass('sortable'))
    const head = e.target
    const atributo = e.target.id
    let orden = ''

    listaSortable.forEach(item => {
      if (item !== head) {
        if (item.classList.contains('asc')) {
          item.classList.remove('asc')
        }
        if (item.classList.contains('desc')) {
          item.classList.remove('desc')
        }
      }

    })


    if (head.classList.contains('asc')) {
      if (head.classList.contains('desc')) {
        head.classList.add('asc')
        orden = 'asc'
      } else {
        head.classList.remove('asc')
        head.classList.add('desc')
        orden = 'desc'
      }
    } else {
      if (head.classList.contains('desc')) {
        head.classList.remove('desc')
        orden = ''
      } else {
        head.classList.add('asc')
        orden = 'asc'
      }
    }


    let copiaRows = [...filas]

    switch (orden) {
      case 'asc':
        copiaRows = copiaRows.sort((prev, next) => {
          return ((prev[atributo]).toString()).localeCompare((next[atributo]).toString())
        })

        setFilas(copiaRows)

        break;

      case 'desc':
        copiaRows = copiaRows.sort((prev, next) => {
          return ((next[atributo]).toString()).localeCompare((prev[atributo]).toString())
        })

        setFilas(copiaRows)
        break;
      default:
        setFilas([...rows])
    }


  }
  const generarReporte = () => {
    const btnGeneraExcel = buscarId('test-table-xls-button')

    btnGeneraExcel.click()
  }

  const updateCurrentRows = () => {
    const indexOfLastPost = currentPage * limitador;
    const indexOfFirstPos = indexOfLastPost - limitador;
    let newRows = filas.slice(indexOfFirstPos, indexOfLastPost)

    setCurrentRows(newRows)
  }

   // Modal para asignar el plan
   const handleEditInediRank = (id_matricula,inedirank) => {
    dispatch(updateStateModalBasic(
      <EditInedirank
        id_matricula={id_matricula}
        inedirank={inedirank}
        updateInediRank={updateInediRank} // Pasa el callback
      />,
      'Actualizar INEDIRANK'
    ));
  };

  const updateInediRank = (id_matricula, newInedirank) => {
    // Clonar y actualizar `rows` para encontrar el registro que necesita actualización
    const updatedRows = filas.map((fila) =>
      fila.id_matricula_proyecto === id_matricula ? { ...fila, inedirank: newInedirank } : fila
    );
    
    // Actualiza `filas` con los datos modificados para reflejar en la tabla
    setFilas(updatedRows);
  };

  useEffect(() => {
    setFilas(rows)
    if (buscarRef.current.value !== '') {
      buscar(buscarRef.current.value)
    }
    let listaAsc = document.querySelector('.sortable.asc')
    let listaDesc = document.querySelector('.sortable.desc')

    if (listaAsc) {
      ordenarColumnas({ target: listaAsc })
    }
    if (listaDesc) {
      ordenarColumnas({ target: listaDesc })
    }
  }, [rows])

  useEffect(() => {
    updateCurrentRows()
  }, [filas, currentPage, limitador])

  const paginate = pageNumber => setCurrentPage(pageNumber)
const calcularPorcentajeAsistencia = (asistidas, realizadas) => {
  const totalAsistidas = Number(asistidas || 0);
  const totalRealizadas = Number(realizadas || 0);

  if (totalRealizadas === 0) return 0;

  return Math.min(
    100,
    Math.round((totalAsistidas / totalRealizadas) * 100)
  );
};

  return (
    <div className="table-report table-hover px-3">

      <div className="menu">
        <div className="row">
          <div className="col-md-4">
            <div className="row">
              <div className="col-md-6">

                <LimitadorFilas />
              </div>
              <div className="col-md-6">

              </div>
            </div>

          </div>
          <div className="col-md-8">
            <div className="content-button w-100 d-flex justify-content-end align-items-center" style={{ gap: '6px' }}>
              <div className="position-relative">
                <button
                  type='button'
                  className='btn btn-secondary btn-sm'
                  onClick={() => setShowColMenu(v => !v)}
                >
                  <i className='fas fa-columns'></i> Columnas
                </button>
                {showColMenu && (
                  <div className="position-absolute bg-white border rounded shadow p-2"
                    style={{ right: 0, top: '100%', zIndex: 999, minWidth: '200px' }}>
                    {columnas.map(col => (
                      <div key={col.key} className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id={`col-${col.key}`}
                          checked={colVisibility[col.key]}
                          onChange={() => toggleCol(col.key)}
                        />
                        <label className="form-check-label" htmlFor={`col-${col.key}`}>
                          {col.label}
                        </label>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <Search buscar={buscar} buscarRef={buscarRef} />
              <button type='button' className='btn btn-primary btn-sm' onClick={() => generarReporte()}>
                <i className='fas fa-file-excel'></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="">
        <table id="table" className="table-responsive">
          <thead >
            <tr>
              <th scope="col" colSpan="3" className='px-5'>
                SEMÁFORO
              </th>
              <th scope="col" colSpan={3 + (colVisibility.correo?1:0) + (colVisibility.telefono?1:0)}>
                DATOS
              </th>
              {colVisibility.deuda && <th scope="col" className="economico agrandar" colSpan="2">ESTADO ECONÓMICO</th>}
              <th scope="col" className="academico agrandar" colSpan={1 + (colVisibility.notaOptima?1:0) + (colVisibility.nota?1:0) + (colVisibility.puntosInedi?1:0) + (colVisibility.puntosEval?1:0) + (colVisibility.totalPuntos?1:0) + 2}>
                ESTADO ACADÉMICO
              </th>
              <th scope="col" rowSpan="2" className="px-3">
  PROGRESO
</th>

              <th scope="col" rowSpan="2" className="px-3">GESTIÓN</th>
              {colVisibility.acciones && <th scope="col" rowSpan="2" className="px-3">ACCIONES</th>}
              {colVisibility.fecha && <th scope="col" rowSpan="2" className='px-5'>FECHA</th>}
              {colVisibility.hora && <th scope="col" rowSpan="2" className='px-5'>HORA</th>}
              {colVisibility.observaciones && <th scope="col" rowSpan="2" className="px-5">OBSERVACIONES</th>}
              {colVisibility.inediTotales && <th scope="col" rowSpan="2" className="px-5">Puntos INEDI TOTALES</th>}
            </tr>
            <tr>
              <th scope="col" className="bg-success"><span style={{ display: 'block', width: '50px', height: '40px' }} onClick={() => { buscar('VERDE') }}></span></th>
              <th scope="col" className="bg-warning"><span style={{ display: 'block', width: '50px', height: '40px' }} onClick={() => { buscar('AMBAR') }}></span></th>
              <th scope="col" className="bg-danger"><span style={{ display: 'block', width: '50px', height: '40px' }} onClick={() => { buscar('ROJO') }}></span></th>

            
              <th className='discente sortable' id='nombre' scope="col" onClick={e => ordenarColumnas(e)}>NOMBRE</th>
              <th className='discente sortable' id='apellido' scope="col" onClick={e => ordenarColumnas(e)}>APELLIDO</th>
              <th scope="col">DNI</th>
              {colVisibility.correo && <th scope="col">CORREO</th>}
              {colVisibility.telefono && <th scope="col">TELÉFONO</th>}
              {colVisibility.deuda && <th scope="col" className='sortable' id='importe_deuda' onClick={e => ordenarColumnas(e)}>DEUDA (S/.)</th>}
              {colVisibility.deuda && <th scope="col">PAGO</th>}
              <th scope="col">ASISTENCIA</th>
              {colVisibility.notaOptima && <th scope='col'>N. ÓPTIMA</th>}
              {colVisibility.nota && <th scope="col" className='sortable nota' id='promedio_final' onClick={e => ordenarColumnas(e)}>NOTA</th>}
              {colVisibility.puntosInedi && <th scope='col'>Puntos INEDI</th>}
              {colVisibility.puntosEval && <th scope='col'>Puntos Evaluaciones</th>}
              {colVisibility.totalPuntos && <th scope='col'>Total Puntos</th>}
              <th scope='col' className='sortable' id='cumplimiento' onClick={e => ordenarColumnas(e)}>CUMPL. ACAD.</th>
              <th scope='col'>RITMO</th>

            </tr>
          </thead>

          <tbody>
            {
              currentRows.length ?
                currentRows.map((fila, index) => (
                  <tr key={index}>
                    <td colSpan="3" className='td-semaforo'>
                      <div style={{
                          background: fila.color_estado === 'AMBAR' ? '#F39C12'
                            : fila.color_estado === 'VERDE' ? '#18BB60'
                            : fila.color_estado === 'GRIS' ? '#95A5A6'
                            : '#E12E1C'
                        }} className='semaforo'>
                        {fila.color_estado}
                      </div>
                    </td>
                  
                    <td>{fila.nombre}</td>
                    <td>{fila.apellido}</td>
                    <td>{fila.dni}</td>
                    {colVisibility.correo && <td>{fila.correo}</td>}
                    {colVisibility.telefono && <td>{fila.telefono}</td>}
                    {colVisibility.deuda && <td className='text-center'>{fila.importe_deuda}</td>}
                    {colVisibility.deuda && (
                      <td className='text-center'>
                        <span style={{
                          color: fila.pago === 'MOROSO' ? '#E12E1C' : '#18BB60',
                          fontWeight: 'bold', fontSize: '12px'
                        }}>
                          {fila.pago === 'MOROSO' ? 'Deuda' : 'Al día'}
                        </span>
                      </td>
                    )}

                    <td className='text-center'>
  <div
    className="asistencia-circulo"
    style={{
      background: `conic-gradient(
        #18bb60 ${calcularPorcentajeAsistencia(fila.cant_asistidas, fila.cant_se_realizada)}%,
        #d9dee8 0
      )`
    }}
  >
    <div className="asistencia-circulo__centro">
      {fila.cant_asistidas}/{fila.cant_se_realizada}
    </div>
  </div>
</td>

                    {colVisibility.notaOptima && <td className='text-center'>{fila.promedio_optimo}</td>}
                    {colVisibility.nota && (
                      <td className='text-center nota'>
                        <a href="#" title='detallar' className='nota__valor'
                          onClick={e => { e.preventDefault(); verNotasSesiones(fila.id_matricula_proyecto) }}>
                          {fila.promedio_final}
                        </a>
                      </td>
                    )}
                    {colVisibility.puntosInedi && <td className='text-center'>{fila.puntos_inedi}</td>}
                    {colVisibility.puntosEval && <td className='text-center'>{fila.puntos_adicionales}</td>}
                    {colVisibility.totalPuntos && <td className='text-center'>{fila.total_puntos}</td>}

                    <td className='text-center'>
                      <CircularProgressWithLabel value={fila.cumplimiento} />
                    </td>

                    <td className='text-center'>
                      <span style={{
                        padding: '3px 8px', borderRadius: '12px', fontSize: '11px', fontWeight: 'bold',
                        background: fila.ritmo === 'AL DÍA' ? '#d4edda'
                          : fila.ritmo === 'PREVENTIVO' ? '#fff3cd'
                          : fila.ritmo === 'RETRASADO' ? '#fde8d8'
                          : fila.ritmo === 'CRÍTICO' ? '#f8d7da'
                          : '#e9ecef',
                        color: fila.ritmo === 'AL DÍA' ? '#155724'
                          : fila.ritmo === 'PREVENTIVO' ? '#856404'
                          : fila.ritmo === 'RETRASADO' ? '#d35400'
                          : fila.ritmo === 'CRÍTICO' ? '#721c24'
                          : '#6c757d'
                      }}>
                        {fila.ritmo}
                      </span>
                    </td>

                   <td className='text-center'>
  <CircularProgressWithLabel value={fila.progreso} />
</td>

                    <td className="text-center">
                      <button className="btn btn-sm btn-outline-primary" style={{ fontSize: '11px' }}
                        onClick={() => setFichaAbierta(fila)}>
                        Gestionar
                      </button>
                    </td>
                    {colVisibility.acciones && <td>{fila.button}</td>}
                    {colVisibility.fecha && <td className='text-center'>{fila.fecha_edicion}</td>}
                    {colVisibility.hora && <td className='text-center'>{fila.hora_edicion}</td>}
                    {colVisibility.observaciones && (
                      <td>
                        <select name="observaciones" disabled value={fila.observaciones || ''} className="form-control">
                          <option value=''>--seleccionar--</option>
                          <option value='cancela_deuda'>Cancelara deuda</option>
                          <option value='activo'>Estará activo</option>
                          <option value='justificar_asistencia'>Justificará asistencia</option>
                          <option value="participa_clase">Participará mas en clases</option>
                          <option value="rendira_evaluacion">Rendirá evaluación extemporánea</option>
                        </select>
                      </td>
                    )}
                    {colVisibility.inediTotales && (
                      <td className='text-center'>
                        {fila.inedirank}
                        <button onClick={() => handleEditInediRank(fila.id_matricula_proyecto, fila.inedirank)} className="ml-3 btn btn-info">
                          <FontAwesomeIcon icon={faEdit} />
                        </button>
                      </td>
                    )}
                  </tr>

                )) : (
                  <tr>
                    <td colSpan='17'>
                      <div className=' text-center my-3'>
                        No hay Filas
                      </div>
                    </td>
                  </tr>
                )
            }


          </tbody>
        </table>
        <div className="footer">


          <Paginacion
            totalRows={rows.length}
            paginate={paginate}

          />
        </div>
      </div>
      <ExportExcel />
      <ModalBasicwithRedux />
      {fichaAbierta && (
        <FichaGestion
          fila={fichaAbierta}
          onClose={() => setFichaAbierta(null)}
        />
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  limitador: state.reporte.limitador
})

export default connect(mapStateToProps, {})(TableReport);
